// extracted by mini-css-extract-plugin
export default {"block":"page404_block__ZXj-5","text":"page404_text__rglae","link":"page404_link__FK-fL"};